var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3422_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.75 0.5C5.11719 0.5 5.47135 0.546875 5.8125 0.640625C6.15365 0.734375 6.47135 0.869792 6.76562 1.04688C7.0599 1.22396 7.32943 1.43229 7.57422 1.67188C7.81901 1.91146 8.02865 2.18099 8.20312 2.48047C8.3776 2.77995 8.51172 3.09896 8.60547 3.4375C8.69922 3.77604 8.7474 4.13021 8.75 4.5C8.75 4.86719 8.70312 5.22135 8.60938 5.5625C8.51562 5.90365 8.38021 6.22135 8.20312 6.51562C8.02604 6.8099 7.81771 7.07943 7.57812 7.32422C7.33854 7.56901 7.06901 7.77865 6.76953 7.95312C6.47005 8.1276 6.15104 8.26172 5.8125 8.35547C5.47396 8.44922 5.11979 8.4974 4.75 8.5C4.38281 8.5 4.02865 8.45312 3.6875 8.35938C3.34635 8.26562 3.02865 8.13021 2.73438 7.95312C2.4401 7.77604 2.17057 7.56771 1.92578 7.32812C1.68099 7.08854 1.47135 6.81901 1.29688 6.51953C1.1224 6.22005 0.988281 5.90104 0.894531 5.5625C0.800781 5.22396 0.752604 4.86979 0.75 4.5C0.75 4.13281 0.796875 3.77865 0.890625 3.4375C0.984375 3.09635 1.11979 2.77865 1.29688 2.48438C1.47396 2.1901 1.68229 1.92057 1.92188 1.67578C2.16146 1.43099 2.43099 1.22135 2.73047 1.04688C3.02995 0.872396 3.34896 0.738281 3.6875 0.644531C4.02604 0.550781 4.38021 0.502604 4.75 0.5ZM5.25 6.5V5.5H4.25V6.5H5.25ZM5.25 5V2.5H4.25V5H5.25Z",
    fill: "#EB5757"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3422_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(0.75 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.7134d9f1da52a51950e74d9e06fb323b.svg";
export { ForwardRef as ReactComponent };